import { createStore, combineReducers, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';
import reducers from '../reducers';

const initialState = {
  teams:[],
  scores: [],
  tournament: 'Amrut Cup'
}

export default function configureStore() {
  return createStore(
    combineReducers({
      ...reducers,
    }),
    initialState,
    applyMiddleware(thunk, createLogger)
  );
}


// WEBPACK FOOTER //
// ./src/config/configureStore.js